define(

    'payment/handlers/sendHandlers/asynchronousResultAfterSingleCallHandler',[],function() {
        'use strict';

        function init(methodNameIn) {}

        function handleSuccessfulResponse(paymentBox, sendHandlerData, accHistRef, paymentFetchResultFlow) {
            var parameterMap = sendHandlerData.parameterMap;
            window.top.getPaymentResult.getAsynchronousPaymentResultAndShowFinalResult(accHistRef, paymentFetchResultFlow);
        }

        function cleanupOnFail() {}

        var asynchronousResultAfterSingleCallHandler = {};
        asynchronousResultAfterSingleCallHandler.init = init;
        asynchronousResultAfterSingleCallHandler.handleSuccessfulResponse = handleSuccessfulResponse;
        asynchronousResultAfterSingleCallHandler.cleanupOnFail = cleanupOnFail;

        return asynchronousResultAfterSingleCallHandler;
    }
);
